// Native American Warriors Data - Group One (First 6 Warriors)

// Crazy Horse's workout programs
const crazyHorsePrograms = [
    {
        id: 'vision-quest-training',
        name: 'Vision Quest Training',
        description: 'Spiritual strength building that connects mind, body, and spirit like the great vision seeker',
        pattern: 'wa@d_a',
        reps: 12,
        sets: 4,
        focus: 'Spiritual Power'
    },
    {
        id: 'plains-warrior-conditioning',
        name: 'Plains Warrior Conditioning',
        description: 'Battle-tested strength forged on the endless grasslands of Lakota territory',
        pattern: '^w@da',
        reps: 15,
        sets: 3,
        focus: 'Battle Readiness'
    },
    {
        id: 'sacred-horse-workout',
        name: 'Sacred Horse Workout',
        description: 'Core stability and balance training inspired by the bond between warrior and horse',
        pattern: '@_wda',
        reps: 10,
        sets: 5,
        focus: 'Mounted Combat'
    },
    {
        id: 'lightning-strike-protocol',
        name: 'Lightning Strike Protocol',
        description: 'Swift and devastating attack conditioning like Crazy Horse\'s surprise raids',
        pattern: 'wa^d@',
        reps: 18,
        sets: 3,
        focus: 'Lightning Speed'
    },
    {
        id: 'lakota-endurance-training',
        name: 'Lakota Endurance Training',
        description: 'Relentless stamina building for warriors who never surrender',
        pattern: 'd@wa^',
        reps: 14,
        sets: 4,
        focus: 'Endless Endurance'
    },
    {
        id: 'legendary-chief-mastery',
        name: 'Legendary Chief Mastery',
        description: 'Complete warrior transformation following the path of the greatest Lakota war leader',
        pattern: 'wa@d^a!',
        reps: 20,
        sets: 3,
        focus: 'Legendary Leadership'
    }
];

// Sitting Bull's workout programs
const sittingBullPrograms = [
    {
        id: 'medicine-man-strength',
        name: 'Medicine Man Strength',
        description: 'Wisdom-guided conditioning that builds both physical and spiritual power',
        pattern: '@wd_a',
        reps: 11,
        sets: 4,
        focus: 'Sacred Strength'
    },
    {
        id: 'sun-dance-endurance',
        name: 'Sun Dance Endurance',
        description: 'Ceremonial conditioning inspired by the most sacred Lakota ritual',
        pattern: 'da@w^',
        reps: 16,
        sets: 3,
        focus: 'Ceremonial Power'
    },
    {
        id: 'buffalo-hunt-training',
        name: 'Buffalo Hunt Training',
        description: 'Powerful leg and core work for the great hunts that sustained the people',
        pattern: '~@da',
        reps: 13,
        sets: 4,
        focus: 'Hunter\'s Power'
    },
    {
        id: 'tribal-leader-conditioning',
        name: 'Tribal Leader Conditioning',
        description: 'Complete leadership strength for those who guide their people through dark times',
        pattern: 'w@^da',
        reps: 17,
        sets: 3,
        focus: 'Leadership Strength'
    },
    {
        id: 'resistance-warrior-workout',
        name: 'Resistance Warrior Workout',
        description: 'Unbreakable conditioning for those who stand against overwhelming odds',
        pattern: '^@wd_',
        reps: 19,
        sets: 3,
        focus: 'Unbreakable Will'
    },
    {
        id: 'great-chief-mastery',
        name: 'Great Chief Mastery',
        description: 'The ultimate training of one of history\'s most respected Native American leaders',
        pattern: '@wd^_a!',
        reps: 22,
        sets: 3,
        focus: 'Great Chief Power'
    }
];

// Red Cloud's workout programs
const redCloudPrograms = [
    {
        id: 'war-bonnet-training',
        name: 'War Bonnet Training',
        description: 'Earned strength where every rep represents a coup counted in battle',
        pattern: 'wa@da',
        reps: 21,
        sets: 3,
        focus: 'Earned Honor'
    },
    {
        id: 'powder-river-conditioning',
        name: 'Powder River Conditioning',
        description: 'Territorial defense training for protecting sacred hunting grounds',
        pattern: '@^wda',
        reps: 14,
        sets: 4,
        focus: 'Territory Defense'
    },
    {
        id: 'strategic-warfare-workout',
        name: 'Strategic Warfare Workout',
        description: 'Tactical conditioning combining physical prowess with battlefield intelligence',
        pattern: 'dw@^a',
        reps: 16,
        sets: 3,
        focus: 'Strategic Mind'
    },
    {
        id: 'treaty-negotiator-strength',
        name: 'Treaty Negotiator Strength',
        description: 'Diplomatic power training for leaders who must be strong in council and war',
        pattern: '_@wda',
        reps: 12,
        sets: 5,
        focus: 'Diplomatic Strength'
    },
    {
        id: 'bozeman-trail-training',
        name: 'Bozeman Trail Training',
        description: 'Victory conditioning commemorating the successful closure of the Bozeman Trail',
        pattern: 'w@da^',
        reps: 18,
        sets: 3,
        focus: 'Victory Path'
    },
    {
        id: 'distinguished-leader-mastery',
        name: 'Distinguished Leader Mastery',
        description: 'Complete mastery training for one of the most successful Native American war leaders',
        pattern: 'wa@^da!',
        reps: 25,
        sets: 3,
        focus: 'Distinguished Leadership'
    }
];

// Black Kettle's workout programs
const blackKettlePrograms = [
    {
        id: 'peace-pipe-conditioning',
        name: 'Peace Pipe Conditioning',
        description: 'Balanced training that builds strength while maintaining peaceful intentions',
        pattern: '@dwa_',
        reps: 10,
        sets: 4,
        focus: 'Peaceful Strength'
    },
    {
        id: 'cheyenne-elder-workout',
        name: 'Cheyenne Elder Workout',
        description: 'Wisdom-based conditioning that reflects years of leadership experience',
        pattern: 'da@w^',
        reps: 13,
        sets: 4,
        focus: 'Elder Wisdom'
    },
    {
        id: 'dual-path-training',
        name: 'Dual Path Training',
        description: 'Training for those who must be ready for both war and peace',
        pattern: 'w@^da',
        reps: 15,
        sets: 3,
        focus: 'Dual Purpose'
    },
    {
        id: 'survival-conditioning',
        name: 'Survival Conditioning',
        description: 'Endurance training for leading people through impossible circumstances',
        pattern: '_@dwa',
        reps: 17,
        sets: 3,
        focus: 'Survival Leadership'
    },
    {
        id: 'colorado-plains-workout',
        name: 'Colorado Plains Workout',
        description: 'Homeland strength training connecting to the vast Colorado territories',
        pattern: 'ad@w^',
        reps: 11,
        sets: 5,
        focus: 'Homeland Power'
    },
    {
        id: 'peacemaker-mastery',
        name: 'Peacemaker Mastery',
        description: 'The complete training of a leader who chose peace in a time of war',
        pattern: '@dw^_a!',
        reps: 19,
        sets: 3,
        focus: 'Peacemaker Legacy'
    }
];

// Roman Nose's workout programs
const romanNosePrograms = [
    {
        id: 'war-bonnet-power-training',
        name: 'War Bonnet Power Training',
        description: 'Legendary strength training under the protection of the sacred war bonnet',
        pattern: 'ewa@d',
        reps: 16,
        sets: 3,
        focus: 'Sacred Protection'
    },
    {
        id: 'cheyenne-height-conditioning',
        name: 'Cheyenne Height Conditioning',
        description: 'Towering strength training befitting the tallest Cheyenne warrior',
        pattern: 'kw@da',
        reps: 18,
        sets: 3,
        focus: 'Towering Power'
    },
    {
        id: 'battle-scars-workout',
        name: 'Battle Scars Workout',
        description: 'Proven warrior conditioning marked by countless battles survived',
        pattern: '@dewa',
        reps: 20,
        sets: 3,
        focus: 'Battle Proven'
    },
    {
        id: 'mounted-warfare-training',
        name: 'Mounted Warfare Training',
        description: 'Horse combat conditioning with sacred symbols for protection',
        pattern: 'wa@ed',
        reps: 14,
        sets: 4,
        focus: 'Mounted Combat'
    },
    {
        id: 'fearless-charge-conditioning',
        name: 'Fearless Charge Conditioning',
        description: 'Devastating frontal assault training for the warrior who knew no fear',
        pattern: 'ek@wa',
        reps: 22,
        sets: 3,
        focus: 'Fearless Assault'
    },
    {
        id: 'legendary-warrior-mastery',
        name: 'Legendary Warrior Mastery',
        description: 'Ultimate training for one of the most feared Cheyenne Dog Soldiers',
        pattern: 'ek@wad!',
        reps: 24,
        sets: 3,
        focus: 'Legendary Fear'
    }
];

// Dull Knife's workout programs
const dullKnifePrograms = [
    {
        id: 'northern-cheyenne-strength',
        name: 'Northern Cheyenne Strength',
        description: 'Resilient conditioning forged in the harsh northern territories',
        pattern: 'hwa@d',
        reps: 12,
        sets: 4,
        focus: 'Northern Resilience'
    },
    {
        id: 'montana-wilderness-training',
        name: 'Montana Wilderness Training',
        description: 'Survival conditioning in the unforgiving Montana mountains',
        pattern: 'mad@w',
        reps: 15,
        sets: 3,
        focus: 'Wilderness Survival'
    },
    {
        id: 'leader-compassion-workout',
        name: 'Leader Compassion Workout',
        description: 'Strength training balanced with the compassion needed to guide a people',
        pattern: '@dwam',
        reps: 11,
        sets: 5,
        focus: 'Compassionate Leadership'
    },
    {
        id: 'winter-endurance-conditioning',
        name: 'Winter Endurance Conditioning',
        description: 'Harsh weather training for surviving the brutal northern winters',
        pattern: 'wa@dm',
        reps: 17,
        sets: 3,
        focus: 'Winter Endurance'
    },
    {
        id: 'tribal-preservation-training',
        name: 'Tribal Preservation Training',
        description: 'Complete conditioning for leaders dedicated to preserving their people',
        pattern: 'da@wm',
        reps: 13,
        sets: 4,
        focus: 'Cultural Preservation'
    },
    {
        id: 'resilient-chief-mastery',
        name: 'Resilient Chief Mastery',
        description: 'Ultimate resilience training for a leader who never broke despite every hardship',
        pattern: 'hwa@dm!',
        reps: 20,
        sets: 3,
        focus: 'Unbreakable Resilience'
    }
];

// Main Native American warriors data object - Group One
const nativeAmericanOneTrainersData = {
    'crazy-horse': {
        id: 'crazy-horse',
        name: 'Crazy Horse',
        specialization: 'Vision Quest & Lightning Warfare Specialist',
        image: '/assets/images/Crazy-Horse.jpg',
        experience: '37+ years',
        category: 'native-american',
        color: '#C0C0C0',
        secondaryColor: '#4169E1',
        intro: `The legendary Lakota war leader who never lost a battle, Crazy Horse combined spiritual vision with lightning-fast tactical brilliance. His training develops the sharp focus needed for both mounted combat and spiritual connection. Students learn that true warrior strength comes from the harmony between physical prowess and spiritual insight.`,
        programs: crazyHorsePrograms
    },
    'sitting-bull': {
        id: 'sitting-bull',
        name: 'Sitting Bull',
        specialization: 'Medicine Power & Resistance Training',
        image: '/assets/images/Sitting-Bull.jpg',
        experience: '59+ years',
        category: 'native-american',
        color: '#B8860B',
        secondaryColor: '#C0C0C0',
        intro: `The sacred medicine man and chief who led his people through their greatest trials, Sitting Bull understood that true strength comes from spiritual power and unwavering resistance. His training builds the unbreakable will needed to stand against impossible odds while maintaining sacred connection to the Great Spirit.`,
        programs: sittingBullPrograms
    },
    'red-cloud': {
        id: 'red-cloud',
        name: 'Red Cloud',
        specialization: 'Strategic Victory & Honor Warfare',
        image: '/assets/images/Red-Cloud.jpg',
        experience: '87+ years',
        category: 'native-american',
        color: '#8B0000',
        secondaryColor: '#C0C0C0',
        intro: `The only Native American leader to win a war against the United States, Red Cloud mastered both battlefield tactics and diplomatic strategy. His training develops the strategic mind and earned strength where every achievement must be fought for and proven in combat.`,
        programs: redCloudPrograms
    },
    'black-kettle': {
        id: 'black-kettle',
        name: 'Black Kettle',
        specialization: 'Peaceful Strength & Dual Path Training',
        image: '/assets/images/Black-Kettle.jpg',
        experience: '70+ years',
        category: 'native-american',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The Cheyenne peace chief who sought harmony even in the darkest times, Black Kettle taught that true strength includes the wisdom to choose peace. His training builds the balanced power needed for leaders who must be ready for both war and peace, always choosing the path that serves their people.`,
        programs: blackKettlePrograms
    },
    'roman-nose': {
        id: 'roman-nose',
        name: 'Roman Nose',
        specialization: 'Sacred Protection & Fearless Combat',
        image: '/assets/images/Roman-Nose.jpg',
        experience: '28+ years',
        category: 'native-american',
        color: '#4B0082',
        secondaryColor: '#C0C0C0',
        intro: `The towering Cheyenne Dog Soldier whose sacred war bonnet made him nearly invincible in battle, Roman Nose embodied fearless courage and spiritual protection. His training develops the explosive power and fearless spirit needed for direct confrontation with any enemy.`,
        programs: romanNosePrograms
    },
    'dull-knife': {
        id: 'dull-knife',
        name: 'Dull Knife',
        specialization: 'Northern Resilience & Cultural Preservation',
        image: '/assets/images/Dull-Knife.jpg',
        experience: '78+ years',
        category: 'native-american',
        color: '#708090',
        secondaryColor: '#C0C0C0',
        intro: `The Northern Cheyenne chief who led his people through impossible hardships to preserve their way of life, Dull Knife represents unbreakable resilience. His training builds the endurance and determination needed to protect what matters most, no matter the cost or sacrifice required.`,
        programs: dullKnifePrograms
    }
};

// Export the data
export default nativeAmericanOneTrainersData;